import { render, staticRenderFns } from "./DashComponent.vue?vue&type=template&id=051aec00"
import script from "./DashComponent.vue?vue&type=script&lang=js"
export * from "./DashComponent.vue?vue&type=script&lang=js"
import style0 from "./DashComponent.vue?vue&type=style&index=0&id=051aec00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports